import { useEffect } from 'react';

/*
 * Thaihand's data is bilingual, while much of the application chrome is still
 * emitted as Thai literals by the individual screens.  Keep those literals as
 * the canonical copy (which makes visual parity audits straightforward) and
 * localise their rendered text here.  Long phrases are replaced before their
 * component words, so dynamic strings such as "แก้ไขการเข้างาน — Som" work too.
 */
const EN = {
  // Complete Thai date strings are emitted by the shop-time helpers. Keeping
  // month names here lets the same DOM localizer translate dynamic dates too.
  'มกราคม': 'January',
  'กุมภาพันธ์': 'February',
  'มีนาคม': 'March',
  'เมษายน': 'April',
  'พฤษภาคม': 'May',
  'มิถุนายน': 'June',
  'กรกฎาคม': 'July',
  'สิงหาคม': 'August',
  'กันยายน': 'September',
  'ตุลาคม': 'October',
  'พฤศจิกายน': 'November',
  'ธันวาคม': 'December',
  'ม.ค.': 'Jan',
  'ก.พ.': 'Feb',
  'มี.ค.': 'Mar',
  'เม.ย.': 'Apr',
  'พ.ค.': 'May',
  'มิ.ย.': 'Jun',
  'ก.ค.': 'Jul',
  'ส.ค.': 'Aug',
  'ก.ย.': 'Sep',
  'ต.ค.': 'Oct',
  'พ.ย.': 'Nov',
  'ธ.ค.': 'Dec',
  'จำนวนบิลบริการทั้งหมด': 'Total treatment bills',
  'รายการอื่น ๆ': 'Other items',
  'เลือกแพ็กเกจฝั่งซ้าย': 'Choose a package on the left',
  'กรุณากรอกข้อมูลลูกค้า': 'Please enter customer information',
  'ต่ำกว่า 20': 'Under 20',
  '60 ปีขึ้นไป': '60 and over',
  'จีน': 'China',
  'ญี่ปุ่น': 'Japan',
  'ฝรั่งเศส': 'France',
  'มาเลเซีย': 'Malaysia',
  'รัสเซีย': 'Russia',
  'สหรัฐอเมริกา': 'United States',
  'สหราชอาณาจักร': 'United Kingdom',
  'สิงคโปร์': 'Singapore',
  'ออสเตรเลีย': 'Australia',
  'อินเดีย': 'India',
  'อิสราเอล': 'Israel',
  'เกาหลีใต้': 'South Korea',
  'เยอรมนี': 'Germany',
  'ไทย': 'Thailand',
  'นักท่องเที่ยว': 'Tourist',
  'นักเรียน/นักศึกษา': 'Student',
  'เจ้าของกิจการ': 'Business owner',
  'การยกเลิกนี้จะยกเลิกบริการที่ยังไม่เสร็จสิ้นทั้งหมดในรายการจองเดียวกัน': 'Cancelling will also cancel every unfinished service in this booking',
  'แก้ไขการจอง': 'Edit booking',
  'ยกเลิกการจอง': 'Cancel booking',
  '· รวมที่ต้องจ่าย': '· total due',
  '฿ ชำระเงิน': '฿ Payment',
  '· ห้อง': '· rooms',
  'ที่ปิดใช้งาน': ' — inactive',
  'ลูกค้าคนที่': 'Customer',
  'ยังไม่ระบุ': 'Not specified',
  'รีเควส': 'Requested',
  'เตียง': 'Bed',
  ' ที่': ' spots',
  'ช่องทางการรับเงินกำหนดโดยระบบ (payment_method) จึงเพิ่มหรือปิดเองไม่ได้': 'Payment channels are defined by the system (payment_method) and cannot be added or disabled here',
  'รายการที่เคยถูกใช้งานจะถูกปิดการใช้งานแทนการลบ เพื่อไม่ให้บิลเก่าเสียหาย': 'Items already in use will be deactivated instead of deleted so older bills remain intact',
  'เพิ่มได้เฉพาะเอเจนซี่ — ช่องทางการจองที่เหลือเป็นค่าคงที่ของระบบ (booking_channel)': 'Only agencies can be added — other booking channels are system values (booking_channel)',
  'สาขาใหม่จะได้หมอนวดและราคาบริการทั้งหมดทันที · ห้องและเตียงต้องเพิ่มเอง': 'A new branch immediately receives all therapists and service prices · rooms and beds must be added separately',
  'หมอนวดยังไม่เริ่มงาน คุณยืนยันเลือกหมอนวดคนนี้หรือไม่?': 'This therapist has not started work. Do you want to select them anyway?',
  'ช่องทางการรับเงินที่ถูกปิดการใช้งาน': 'Inactive payment channels',
  'ประเภทบริการเฉพาะที่หมอนวดสามารถทำได้': 'Specific service types this therapist can perform',
  'ยังไม่มีเอเจนซี่ — เพิ่มได้ที่ ตั้งค่า → ช่องทางการจอง': 'No agencies — add one in Settings → Booking channels',
  'ยังไม่มีบริการ — เพิ่มได้ที่ ตั้งค่า → บริการ': 'No services — add one in Settings → Services',
  'อิงตาม วันและเวลาที่ร้านระบุเวลาชำระเงินเข้ามา': 'Based on the payment date and time entered by the store',
  'อิงตาม วันและเวลาที่ลูกค้าเข้าใช้บริการ': 'Based on the date and time the customer received the service',
  'ข้อมูลผู้จองตรงกับลูกค้าคนที่ 1': 'Booking contact matches customer 1',
  'สถานะเชื่อมต่อการแจ้งเตือนกับ LINE': 'LINE notification connection status',
  'วิธีการเชื่อมต่อกับ LINE': 'How to connect LINE',
  'กำหนดสีแถบการ์ดการจอง': 'Set booking card stripe color',
  'การแสดงข้อมูลการทำงานหมอนวด': 'Therapist work information display',
  'ช่วงเวลา และราคาของบริการ': 'Service duration and pricing',
  'จำนวนลูกค้าตามเวลา': 'Customer count by time',
  'พิมพ์รายการค่ามือหมอ': 'Print therapist commission entries',
  'เลือกวันสุดท้ายในการเคลียร์ค่ามือ': 'Select the last day to include in settlement',
  'บังคับให้กรอกรหัสเอเจนซี่': 'Require agency code',
  'ประวัติการให้บริการ': 'Service history',
  'รายละเอียดคำสั่งซื้อ': 'Order details',
  'รายการแยกตามบริการ': 'Items by service',
  'ตั้งค่าแสดงผลบนเว็บไซต์': 'Website display settings',
  'ตัวอย่างการแสดงผล': 'Display preview',
  'เพิ่มเตียงสำหรับบริการนี้': 'Add a bed for this service',
  'เปิดหน้าเว็บลูกค้า': 'Open customer website',
  'ไม่มีช่องทางที่ถูกปิดการใช้งาน': 'No inactive channels',
  'ไม่มีหมอนวดในกลุ่มนี้': 'No therapists in this group',
  'ไม่แสดงข้อมูลการทำงาน': 'Do not show work information',
  'ข้อมูลใบเสร็จ': 'Receipt information',
  'จำนวนเงินในลิ้นชัก': 'Cash in drawer',
  'ส่วนต่างของเงินสด': 'Cash difference',
  'รอบเปิดแคชเชียร์ :': 'Cashier round:',
  'ค่าประกันรายวัน (บาท)': 'Daily guarantee (THB)',
  'ประกันมือต่อวัน :': 'Daily guarantee:',
  'ประกันมือต่อวัน': 'Daily guarantee',
  'ค่ามือค้างชำระ': 'Outstanding commission',
  'ค่ามือที่ต้องจ่าย': 'Commission due',
  'QR พร้อมเพย์': 'PromptPay QR',
  'QR พร้อมเพย์สำหรับจ่ายค่ามือ': 'PromptPay QR for commission payments',
  'อัปโหลดรูป QR': 'Upload QR image',
  'เปลี่ยนรูป QR': 'Replace QR image',
  'ลบรูป QR': 'Remove QR image',
  'ยังไม่มี QR พร้อมเพย์': 'No PromptPay QR yet',
  'กดรูปเพื่อขยายสำหรับสแกน': 'Click the image to enlarge it for scanning',
  'สแกนและตรวจสอบชื่อผู้รับในแอปธนาคารก่อนยืนยันการโอน': 'Scan and verify the recipient in the banking app before confirming the transfer',
  'ค่ามือรวม :': 'Total commission:',
  'เลือกสำหรับลูกค้าคนที่': 'Select for customer',
  'เลือกบริการเสริม': 'Select add-on services',
  'เลือกช่องทางการจอง': 'Select booking channel',
  'เลือกหมวดหมู่': 'Select category',
  'เลือกเหตุผล…': 'Select a reason…',
  'เลือกทั้งหมด': 'Select all',
  'กรุณาเลือกบริการด้านซ้าย': 'Please select a service on the left',
  'บริการที่ขอ': 'Requested services',
  'บริการประจำ': 'Regular services',
  'บริการยอดนิยม': 'Popular services',
  'หมอนวดประจำ': 'Regular therapists',
  'หมอนวดพักงานหรือเลิกจ้าง': 'Suspended or former therapists',
  'รอจัดหมอนวด': 'Awaiting therapist assignment',
  'รายการรอจัดสรร': 'unallocated reservations',
  'จัดสรรเว็บจองของวันนี้ก่อน': "Finish today's web reservations first",
  'กรุณาจัดสรรคำขอจองออนไลน์ของวันนี้ให้เสร็จก่อน จึงจะสามารถสร้างรายการจองใหม่ได้': "Finish allocating all of today's online reservations before creating a new booking.",
  'ไม่ได้ระบุบริการมา': 'No service specified',
  'ไม่ระบุเตียง': 'Bed not assigned',
  'เตียงทั้งหมด': 'All beds',
  'เตียงว่าง': 'Available beds',
  'ว่างขณะนี้': 'Available now',
  'ว่าง': 'Available',
  'ช่วงวันที่': 'Date range',
  'ช่วงอายุ': 'Age range',
  'วันเวลาที่จอง': 'Booked date and time',
  'วันที่จอง': 'Booking date',
  'วันที่มีผล': 'Effective date',
  'วันทำงาน': 'Working days',
  'เวลาบริการ': 'Service time',
  'เวลาเข้างาน': 'Check-in time',
  'เวลาเลิกงาน': 'End time',
  'เวลาเตรียมการ': 'Preparation time',
  'เวลาซื้อ': 'Purchase time',
  'เวลาเปิด': 'Opening time',
  'เวลาปิด': 'Closing time',
  'เวลา (นาที)': 'Time (minutes)',
  'เพิ่มช่วงเวลา': 'Add time range',
  'เพิ่มลูกค้าใหม่': 'Add a new customer',
  'แตะเพื่อเพิ่มลูกค้า': 'Tap to add a customer',
  'ใส่ชื่อผู้จอง': 'Enter booking contact name',
  'ชื่อ (เว้นว่าง = ลูกค้าไม่ระบุชื่อ)': 'Name (blank = anonymous customer)',
  'หมายเหตุเฉพาะการจองนี้': 'Note for this booking only',
  'หมายเหตุเฉพาะรายการนี้': 'Note for this item only',
  'ผู้จอง': 'Booking contact',
  'รหัสจอง': 'Booking code',
  'คำสั่งซื้อ': 'Orders',
  'บิล': 'Bills',
  'ยอดซื้อแพ็กเกจ': 'Package purchases',
  'ยอดเปิด': 'Opening balance',
  'ยอดสุทธิ': 'Net total',
  'ยอดรวม': 'Total',
  'จ่ายสุทธิ': 'Net payable',
  'ค้างชำระ': 'Outstanding',
  'รวม': 'Total',
  'การชำระเงิน': 'Payments',
  'ช่องทางการชำระ': 'Payment channel',
  'ค่ามือรวม': 'Total commission',
  'เคลียร์โดย': 'Settled by',
  'เงินรับพิเศษ': 'Bonuses',
  'เงินหักพิเศษ': 'Deductions',
  'เซอร์วิสชาร์จ': 'Service charge',
  'เรียกเก็บค่าเซอร์วิสชาร์จ': 'Apply service charge',
  '% คอมมิชชั่น': '% commission',
  'รายได้บริการ': 'Service revenue',
  'รายได้สินค้า': 'Product revenue',
  'รายได้': 'Revenue',
  'สรุปรายวัน': 'Daily summary',
  'ดาวน์โหลดข้อมูล': 'Download data',
  'ระบบคำนวณ': 'Calculated by system',
  'นับได้': 'Counted',
  'ขาดอีก': 'Short by',
  'ตันทุน': 'Cost',
  'ราคาลด': 'Discounted price',
  'ระยะเวลาใช้งาน': 'Validity period',
  'หมวดหมู่': 'Category',
  'สี': 'Color',
  'เลขอ้างอิง': 'Reference number',
  'สร้างเมื่อ': 'Created',
  'สาขาปัจจุบัน': 'Current branch',
  'ผู้มีสิทธิ์': 'Authorized users',
  'ผู้ใช้': 'Users',
  'รหัสผ่านปัจจุบัน': 'Current password',
  'รหัสย่อเตียง': 'Bed abbreviation',
  'ยังไม่ได้เชื่อมต่อ': 'Not connected',
  'เชื่อมต่อสำเร็จแล้ว': 'Connected successfully',
  'ยังไม่มีโลโก้': 'No logo',
  'ไม่มีรายชื่อ': 'No names',
  'ยังไม่มี': 'None yet',
  'ดูทั้งหมด': 'View all',
  'กลับหน้าหลัก': 'Back to home',
  'ต่อไป': 'Continue',
  'ถัดไป': 'Next',
  'ปฏิเสธ': 'Decline',
  'พิมพ์': 'Print',
  'ลงกล่องข้อความ': 'Send to message box',
  'ลบรูป': 'Remove image',
  'อัพโหลดรูป': 'Upload image',
  'ต้องการลบ': 'Delete',
  'ใช่หรือไม่?': 'Are you sure?',
  'เหตุผลที่ปฏิเสธ': 'Decline reason',
  'เหตุผล': 'Reason',
  'รอบที่': 'Round',
  'จัดแล้ว': 'Assigned',
  'เริ่ม': 'Start',
  'วัน': 'days',
  'เวลา': 'Time',
  'ชม.': 'hrs.',
  'น.': '',
  ' · รวมที่ต้องจ่าย ': ' · total due ',
  'ขายสินค้าใช้ปุ่ม ซื้อสินค้า บนหน้าหลัก': 'Use Buy products on the home page to sell products',
  'สร้างช่องทางการจอง (เอเจนซี่)': 'Create booking channel (agency)',
  'ไม่สามารถปรับได้ / สามารถปรับได้': 'Not adjustable / adjustable',
  'สำหรับลูกค้าคนเดียว': 'For one customer',
  'สำหรับลูกค้า 2 คน': 'For two customers',
  'แสดงเฉพาะชื่อจริง': 'Show first name only',
  'ยังไม่มีผู้ใช้สิทธิ์นี้': 'No users with this role',
  'ยังไม่ระบุหมอ': 'Therapist not assigned',
  'ชื่อ (อังกฤษ)': 'Name (English)',
  'ชื่อ (ไทย)': 'Name (Thai)',
  'รหัส (2 ตัวอักษร)': 'Code (2 characters)',
  'แก้ไขเอเจนซี่': 'Edit agency',
  'เช่น น้ำหนักมือเบา, แพ้น้ำมันบางชนิด': 'e.g. light pressure, oil allergy',
  'เช่น เบิกล่วงหน้า': 'e.g. advance payment',
  'เช่น โบนัสพิเศษ': 'e.g. special bonus',
  'จอง / กำลังนวด': 'Booked / in service',
  'ไม่ระบุกลุ่ม': 'No group',
  'ใบเสร็จรับเงิน': 'Receipt',
  'ลิงก์รูปภาพ': 'Image URL',
  'เพิ่มบาร์โค้ด': 'Add barcode',
  'ชื่อเอเจนซี่': 'Agency name',
  'เอเจนซี่': 'Agency',
  'ผู้ติดต่อ': 'Contact person',
  'แก้ไขกลุ่ม': 'Edit group',
  'ลบช่วงเวลา': 'Remove time range',
  'จำนวนเงิน': 'Amount',
  'ค่าเริ่มต้น': 'Default',
  'ราคาขาย': 'Sale price',
  'ต้องจ่าย': 'Amount due',
  'รับเงิน': 'Take payment',
  'คืนเงิน': 'Refund',
  'ชาร์จ': 'Charge',
  'รอคิว': 'Waiting',
  'รหัสสิทธิ์': 'Role code',
  'สิทธิ์': 'Role',
  'สินค้า': 'Products',
  'เมนู': 'Menu',
  'ทั้งหมด': 'All',
  'ผสม': 'Mixed',
  'การจอง': 'Bookings',
  'จอง/รับเงิน': 'Booking / payment',
  'จองเลย': 'Book now',
  'กำลังเปลี่ยน…': 'Switching…',
  'กรุณากรอก': 'Please enter a value',
  'คำขอล้มเหลว': 'Request failed',
  '3 รอบ': '3 rounds',
  '4:30 ชม.': '4:30 hrs.',
  'จันทร์': 'Monday',
  'อังคาร': 'Tuesday',
  'พุธ': 'Wednesday',
  'พฤหัสบดี': 'Thursday',
  'ศุกร์': 'Friday',
  'เสาร์': 'Saturday',
  'อาทิตย์': 'Sunday',
  'จ.': 'Mon',
  'อ.': 'Tue',
  'พ.': 'Wed',
  'พฤ.': 'Thu',
  'ศ.': 'Fri',
  'ส.': 'Sat',
  'อา.': 'Sun',
  'การขายแพ็กเกจต้องเลือกลูกค้าก่อน — ค้นหาหรือเพิ่มลูกค้าทางด้านขวา': 'Select a customer before selling a package — search or add one on the right',
  'ปรับตามเวลาจองอัตโนมัติ (ใช้เวลาชำระจริงก่อนเวลาจอง)': 'Adjust automatically to booking time (use actual payment time when earlier)',
  'ไม่สลับคิวหมอ ยึดลำดับคิวเริ่มงาน': 'Keep the therapist queue in check-in order',
  'สลับคิวหมอ คิวล่าสุดอยู่บนสุดเสมอ': 'Rotate the therapist queue, latest queue first',
  'ยอดที่ใช้จ่ายได้ — มากกว่าราคาขายเมื่อมีส่วนแถม': 'Redeemable value — may exceed sale price when a bonus is included',
  'ผู้ใช้สิทธิ์นี้ถูกปิดการใช้งานทั้งหมด': 'All users with this role are inactive',
  'นับรวมครั้งที่แถม — ซื้อ10 ฟรี1 คือ 11': 'Include bonus visits — buy 10 get 1 means 11',
  'ยังไม่รองรับ — ระบบหลังบ้านไม่มีที่เก็บค่านี้': 'Not supported — the backend has no field for this value',
  'ทำได้บางคน / บริการทั่วไปทำได้ทุกคน': 'Selected therapists / general services are available to everyone',
  'รหัสผ่านใหม่ (อย่างน้อย 8 ตัวอักษร)': 'New password (at least 8 characters)',
  'ตั้งค่าการจ่ายค่าทิปให้กับหมอนวด': 'Configure therapist tip payouts',
  'สิทธิ์ขั้นต่ำในการแก้ไขค่ามือหมอ': 'Minimum role required to adjust commission',
  'รูปแบบการแสดงผลหน้าการจอง': 'Booking page display format',
  'ช่องทางการจอง/รับเงิน': 'Booking / payment channels',
  'ค้นหาสินค้า หรือสแกนบาร์โค้ด': 'Search products or scan a barcode',
  'เลือกสินค้าจากฝั่งซ้ายมือ หรือสแกนบาร์โค้ด': 'Choose a product on the left or scan a barcode',
  'เลือกแพ็กเกจจากฝั่งซ้ายมือ': 'Choose a package on the left',
  'ค้นหาลูกค้าโดยชื่อและเบอร์โทร': 'Search customers by name and phone',
  'ยังไม่ได้ตั้งค่าเวลาทำการของสาขานี้': 'Business hours have not been configured for this branch',
  'การจองผ่านเอเจนซี่ต้องระบุเอเจนซี่': 'Agency bookings must specify an agency',
  'สามารถปรับราคาบริการก่อนชำระเงินได้': 'Service price can be adjusted before payment',
  'แสดงผล Custom ID ของลูกค้า': 'Show customer custom ID',
  'แสดงค่ามือในหน้าชำระเงิน': 'Show commission on the payment screen',
  'แสดงจำนวนครั้งในการรีเควส': 'Show request count',
  'แสดงจำนวนชั่วโมงในหน้าแรก': 'Show hours on the home page',
  'แสดงจำนวนรอบในหน้าแรก': 'Show rounds on the home page',
  'เวลาเตรียมการเริ่มต้น (นาที)': 'Preparation time before (minutes)',
  'เวลาเตรียมการสิ้นสุด (นาที)': 'Preparation time after (minutes)',
  'ข้อควรระวัง ภาษาอังกฤษ': 'Precautions in English',
  'ข้อควรระวัง ภาษาไทย': 'Precautions in Thai',
  'คำอธิบายบริการ ภาษาอังกฤษ': 'Service description in English',
  'คำอธิบายบริการ ภาษาไทย': 'Service description in Thai',
  'ชื่อกลุ่มบริการ (ภาษาอังกฤษ)': 'Service group name (English)',
  'ชื่อกลุ่มบริการ (ภาษาไทย)': 'Service group name (Thai)',
  'ชื่อกลุ่มสินค้า': 'Product group name',
  'ชื่อบริการ ภาษาอังกฤษ': 'Service name in English',
  'ชื่อบริการ ภาษาไทย': 'Service name in Thai',
  'ชื่อ (ภาษาอังกฤษ) :': 'Name (English):',
  'ชื่อ (ภาษาไทย) :': 'Name (Thai):',
  'ที่อยูุ่ (ภาษาอังกฤษ) :': 'Address (English):',
  'ที่อยูุ่ (ภาษาไทย) :': 'Address (Thai):',
  'ใบเสร็จ/ใบกำกับภาษี': 'Receipt / tax invoice',
  'ใบกำกับภาษีแบบย่อ': 'Abbreviated tax invoice',
  'ตั้งค่าประเภทใบเสร็จ :': 'Receipt type:',
  'ตั้งค่าภาษาเริ่มต้น :': 'Default language:',
  'เวลา เปิด/ปิด ร้าน': 'Business opening / closing hours',
  'ปฏิเสธคำขอจองออนไลน์': 'Decline online booking request',
  'กรุณาเลือกบริการให้ครบทุกรายการ': 'Please select a service for every item',
  'กรุณาเลือกบริการอย่างน้อย 1 รายการ': 'Please select at least one service',
  'กรุณาเลือกรายการอย่างน้อย 1 รายการ': 'Please select at least one item',
  'กรุณาเลือกอย่างน้อย 1 รายการ': 'Please select at least one item',
  'กรุณาเลือกเหตุผลที่ปฏิเสธ': 'Please select a decline reason',
  'กรุณากรอกจำนวนลูกค้า': 'Please enter the number of customers',
  'กรุณากรอกชื่อบริการ': 'Please enter a service name',
  'กรุณากรอกชื่อเตียง': 'Please enter a bed name',
  'กรุณากรอกชื่อเล่น': 'Please enter a nickname',
  'กรุณากรอกรหัสย่อเตียง': 'Please enter a bed abbreviation',
  'กรุณากรอกรหัสหมอนวด': 'Please enter a therapist code',
  'จำนวนเงินต้องมากกว่า 0': 'Amount must be greater than 0',
  'PIN ใหม่ไม่ตรงกัน': 'New PINs do not match',
  'รหัสผ่านทั้งสองช่องไม่ตรงกัน': 'Passwords do not match',
  'รหัสผ่านใหม่ไม่ตรงกัน': 'New passwords do not match',
  'เปลี่ยนรหัสผ่าน': 'Change password',
  'เปลี่ยนรหัส PIN': 'Change PIN',
  'ตั้งรหัสผ่านใหม่': 'Set a new password',
  'ตั้งรหัสผ่าน': 'Set password',
  'ตั้งรหัส PIN': 'Set PIN',
  'รหัสผ่านใหม่': 'New password',
  'รหัสผ่าน': 'Password',
  'ยืนยันรหัสผ่านใหม่': 'Confirm new password',
  'ยืนยัน PIN ใหม่': 'Confirm new PIN',
  'PIN ใหม่ (4-6 หลัก)': 'New PIN (4–6 digits)',
  'อย่างน้อย 8 ตัวอักษร': 'At least 8 characters',
  'เบอร์โทร / Email / User ID': 'Phone / Email / User ID',
  'กำลังเข้าสู่ระบบ…': 'Signing in…',
  'เข้าสู่ระบบ': 'Sign in',
  'ข้อมูลการจอง': 'Booking information',
  'ยืนยันการจอง': 'Confirm booking',
  'เริ่มการจองจากหน้าหลัก': 'Start the booking from the home page',
  'จัดหมอนวดและเตียง': 'Assign therapist and bed',
  'จองออนไลน์': 'Online booking',
  'จองล่วงหน้า': 'Advance booking',
  'ประเภทการจอง': 'Booking type',
  'ช่องทางการจอง': 'Booking channel',
  'เวลาจอง': 'Booking time',
  'ชื่อผู้จอง': 'Booked by',
  'ความต้องการพิเศษล่าสุด': 'Latest special request',
  'ไม่มาตามนัด': 'No-show',
  'ยังไม่มา / เลยเวลาจอง': 'Not arrived / past booking time',
  'ถึงร้านแล้ว': 'Arrived',
  'รอยืนยัน': 'Awaiting confirmation',
  'ยืนยันแล้ว': 'Confirmed',
  'ปฏิเสธลูกค้า': 'Turn away customer',
  'จำนวนลูกค้า': 'Number of customers',
  'ลูกค้าทั่วไป': 'Walk-in customer',
  'ลูกค้าไม่ระบุชื่อ': 'Anonymous customer',
  'กรอกรายละเอียดลูกค้า': 'Enter customer details',
  'ซ่อนรายละเอียดลูกค้า': 'Hide customer details',
  'สร้างลูกค้า': 'Create customer',
  'แก้ไขลูกค้า': 'Edit customer',
  'ค้นหาชื่อ/อีเมล/เบอร์โทร': 'Search name / email / phone',
  'ชื่อ/เบอร์โทรศัพท์': 'Name / phone number',
  'เบอร์โทรศัพท์': 'Phone number',
  'รหัสสมาชิก': 'Member code',
  'มาครั้งล่าสุดเมื่อ': 'Last visit',
  'จำนวนครั้งที่มา': 'Visit count',
  'ยอดรวมการซื้อ': 'Total purchases',
  'ความต้องการพิเศษ': 'Special requests',
  'วันเกิดเดือนนี้': 'Birthdays this month',
  'วันเกิด': 'Date of birth',
  'สัญชาติ': 'Nationality',
  'อาชีพ': 'Occupation',
  'เพศ': 'Gender',
  'หญิง': 'Female',
  'ชาย': 'Male',
  'อายุ': 'Age',
  'สร้างบริการใหม่': 'Create a new service',
  'สร้างกลุ่มบริการ': 'Create service group',
  'แก้ไขกลุ่มบริการ': 'Edit service group',
  'เพิ่มบริการในกลุ่มนี้': 'Add a service to this group',
  'กลุ่มบริการ': 'Service groups',
  'สร้างกลุ่มสินค้า': 'Create product group',
  'เพิ่มสินค้าในกลุ่มนี้': 'Add a product to this group',
  'กลุ่มสินค้า': 'Product groups',
  'สร้างบริการ': 'Create service',
  'แก้ไขบริการ': 'Edit service',
  'ค้นหาบริการ': 'Search services',
  'ชื่อบริการ': 'Service name',
  'ประเภทบริการ': 'Service type',
  'บริการเดี่ยว': 'Single service',
  'บริการคอมโบ': 'Combo service',
  'บริการเสริม': 'Add-on service',
  'บริการ 4 Hands': 'Four-hands service',
  'รองรับบริการนี้': 'Supports this service',
  'ไม่รองรับบริการนี้': 'Does not support this service',
  'ลบบริการเสริม': 'Remove add-on',
  'คำอธิบายบริการ': 'Service description',
  'ราคา': 'Price',
  'ระยะเวลาใช้งาน (วัน)': 'Validity (days)',
  'เวลาเริ่มบริการ': 'Service start time',
  'เริ่มบริการ': 'Start service',
  'กำลังนวด': 'In service',
  'เสร็จสิ้น': 'Completed',
  'สถานะบริการ': 'Service status',
  'สินค้าและบริการ': 'Products and services',
  'ซื้อสินค้า': 'Buy products',
  'ซื้อแพ็กเกจ': 'Buy packages',
  'สร้างสินค้า': 'Create product',
  'แก้ไขสินค้า': 'Edit product',
  'ค้นหาสินค้า': 'Search products',
  'ชื่อสินค้า': 'Product name',
  'จำนวนสินค้าคงเหลือ': 'Stock quantity',
  'เพิ่มจำนวนสินค้า': 'Increase stock',
  'ลดจำนวนสินค้า': 'Decrease stock',
  'ต้นทุนสินค้า': 'Product cost',
  'ยอดขายสินค้า': 'Product sales',
  'ยอดขายแพ็กเกจ': 'Package sales',
  'สร้างแพ็กเกจ': 'Create package',
  'แก้ไขแพ็กเกจ': 'Edit package',
  'ค้นหาแพ็กเกจ': 'Search packages',
  'จำนวนครั้ง': 'Number of visits',
  'เว้นว่าง = ไม่หมดอายุ': 'Leave blank = no expiry',
  'สร้างโปรโมชั่น': 'Create promotion',
  'แก้ไขโปรโมชั่น': 'Edit promotion',
  'ประเภทส่วนลด': 'Discount type',
  'เปอร์เซ็นต์ (%)': 'Percentage (%)',
  'แทนเงินสด': 'Cash value',
  'มูลค่าแทนเงินสด': 'Cash value',
  'เฉพาะสมาชิกที่มีระดับ': 'Members of selected levels only',
  'ใช้กับทั้งหมด': 'Apply to all',
  'ชำระเงิน': 'Payment',
  'ยืนยันการชำระเงิน': 'Confirm payment',
  'ช่องทางการชำระเงิน': 'Payment method',
  'ช่องทางการรับเงิน': 'Payment channel',
  'เวลาชำระเงินเริ่มต้น': 'Default payment time',
  'เวลาชำระเงิน': 'Payment time',
  'ตามเวลาชำระเงินจริง': 'Use actual payment time',
  'หมายเหตุการชำระเงิน': 'Payment note',
  'สถานะการชำระเงิน': 'Payment status',
  'ชำระบางส่วน': 'Partially paid',
  'ชำระแล้ว': 'Paid',
  'ยังไม่ชำระ': 'Unpaid',
  'ยอดชำระสุทธิ': 'Net payment',
  'ราคารวม': 'Total price',
  'ยอดตัดจากแพ็กเกจ': 'Package redemption',
  'ส่วนลด': 'Discount',
  'เงินสด': 'Cash',
  'เงินโอน': 'Bank transfer',
  'บัตรเครดิต': 'Credit card',
  'เงินเข้าบัญชี': 'Bank deposit',
  'แคชเชียร์': 'Cashier',
  'เปิดแคชเชียร์': 'Open cashier',
  'ปิดแคชเชียร์': 'Close cashier',
  'ยังไม่ได้เปิดแคชเชียร์วันนี้': 'The cashier has not been opened today',
  'ยอดเปิดแคชเชียร์': 'Opening float',
  'ยอดเงินสดปัจจุบัน': 'Current cash',
  'นำเงินเข้า': 'Cash in',
  'นำเงินออก': 'Cash out',
  'เพิ่มเงินเข้าลิ้นชัก เป็นจำนวน': 'Amount to add to drawer',
  'นำเงินออกจากลิ้นชัก เป็นจำนวน': 'Amount to remove from drawer',
  'หักเงินจากแคชเชียร์': 'Deduct from cashier',
  'ไม่หักเงินจากแคชเชียร์': 'Do not deduct from cashier',
  'รายรับแคชเชียร์': 'Cashier income',
  'รายจ่ายแคชเชียร์': 'Cashier expenses',
  'ส่วนต่าง': 'Difference',
  'ประเภทการทำรายการ': 'Transaction type',
  'เลขที่รายการ': 'Transaction number',
  'ดูรายละเอียดบิล': 'View bill details',
  'รายละเอียดออเดอร์': 'Order details',
  'รหัสออเดอร์': 'Order ID',
  'ประวัติ': 'History',
  'เข้างาน': 'Check-in',
  'ยังไม่เข้างาน': 'Not checked in',
  'รอเข้างาน': 'Waiting to check in',
  'เริ่มงาน': 'Start shift',
  'เลิกงาน': 'End shift',
  'ทำงาน': 'Working',
  'พัก': 'Break',
  'ลา': 'Leave',
  'ขาด': 'Absent',
  'พักงาน': 'Suspended',
  'กลับมาทำงาน': 'Return to work',
  'แก้ไขการเข้างาน': 'Edit attendance',
  'เปลี่ยนสถานะ': 'Change status',
  'การแสดงผลตารางหมอนวด': 'Therapist board display',
  'หมอนวด': 'Therapists',
  'สร้างหมอนวด': 'Create therapist',
  'แก้ไขหมอนวด': 'Edit therapist',
  'ค้นหาหมอนวด': 'Search therapists',
  'ยังไม่มีหมอนวดเข้างาน': 'No therapists checked in',
  'ยังไม่มีหมอนวดประจำ': 'No regular therapists',
  'ยังไม่มีบริการประจำ': 'No regular services',
  'ประเภทหมอนวด': 'Therapist type',
  'ประจำ (Full Time)': 'Full time',
  'ชั่วคราว (Part Time)': 'Part time',
  'ฟรีแลนซ์': 'Freelance',
  'เพศของหมอนวด': 'Therapist gender',
  'ประกันมือ': 'Guaranteed commission',
  'ค่ามือหมอนวด': 'Therapist commission',
  'ค่ามือ': 'Commission',
  'รายการค่ามือ': 'Commission entries',
  'เคลียร์ค่ามือ': 'Settle commission',
  'ยังไม่มีประวัติการเคลียร์ค่ามือ': 'No settlement history',
  'เพิ่มเงินรับพิเศษ': 'Add bonus',
  'เพิ่มเงินหักพิเศษ': 'Add deduction',
  'ค่ารีเควส': 'Request fee',
  'ค่าคอมเอเจนซี่': 'Agency commission',
  'ค่าคอมแบบคงที่': 'Fixed commission',
  'ค่าคอม (%)': 'Commission (%)',
  'ทิป': 'Tip',
  'รายงาน': 'Reports',
  'รายรับทั้งหมด': 'Total income',
  'รายรับจากการใช้บริการ': 'Service income',
  'จำนวนบิล': 'Number of bills',
  'ราคาเฉลี่ยต่อบิล': 'Average per bill',
  'ราคาเฉลี่ยต่อคน': 'Average per customer',
  'สัดส่วนรายได้': 'Revenue share',
  'สัดส่วนจำนวนครั้ง': 'Visit share',
  'ไม่มีข้อมูลในช่วงนี้': 'No data in this period',
  'รายวัน (Daily)': 'Daily',
  'ตามรายการ': 'By item',
  'ตามลูกค้า': 'By customer',
  'ลูกค้า': 'Customers',
  'เว็บจอง': 'Booking website',
  'ไม่มีคำขอจองใหม่': 'No new booking requests',
  'ตั้งค่า': 'Settings',
  'ทั่วไป': 'General',
  'บริการ': 'Services',
  'โปรโมชั่น': 'Promotions',
  'แพ็กเกจ': 'Packages',
  'ห้องนวด': 'Treatment rooms',
  'ใบเสร็จ': 'Receipts',
  'สิทธิ์เข้าใช้': 'Access control',
  'ประเภทสิทธิ์': 'Role type',
  'สร้างประเภทสิทธิ์': 'Create role',
  'แก้ไขประเภทสิทธิ์': 'Edit role',
  'สิทธิ์การใช้งาน': 'Permissions',
  'สร้างผู้มีสิทธิ์เพิ่ม': 'Add user',
  'แก้ไขผู้มีสิทธิ์': 'Edit user',
  'สาขาที่เข้าใช้ได้': 'Allowed branches',
  'ยังไม่ได้กำหนดสิทธิ์': 'No role assigned',
  'ผู้ใช้ที่ปิดการใช้งาน': 'Inactive users',
  'ไม่พบผู้ใช้ที่ค้นหา': 'No matching users',
  'ชื่อผู้ใช้': 'Username',
  'เจ้าของ': 'Owner',
  'ผู้จัดการ': 'Manager',
  'พนักงานทั่วไป': 'Staff',
  'ข้อมูลร้าน': 'Store information',
  'ชื่อร้าน': 'Store name',
  'ที่อยู่ร้าน': 'Store address',
  'เลขประจำตัวผู้เสียภาษี': 'Tax ID',
  'โลโก้': 'Logo',
  'สาขา': 'Branches',
  'เพิ่มสาขา': 'Add branch',
  'ปิดสาขา': 'Close branch',
  'เปิดอีกครั้ง': 'Reopen',
  'สลับไปสาขาอื่นก่อนจึงจะปิดได้': 'Switch to another branch before closing this one',
  'ยังไม่มีสาขา': 'No branches',
  'ชื่อสาขา': 'Branch name',
  'ชื่อสาขา (ไทย)': 'Branch name (Thai)',
  'รหัสสาขา': 'Branch code',
  'ทุกสาขา': 'All branches',
  'รายรับแยกตามสาขา': 'Revenue by branch',
  'สาขาที่ลงทะเบียน': 'Registered branch',
  'เลือกสาขารายงาน': 'Select report branch',
  'เลือกสาขาค่ามือ': 'Select commission branch',
  'เลือกสาขาลูกค้า': 'Select customer branch',
  'เลือกสาขาหมอนวด': 'Select therapist branch',
  'ห้องส่วนตัว': 'Private room',
  'สร้างห้อง': 'Create room',
  'แก้ไขห้อง': 'Edit room',
  'ลบห้อง': 'Delete room',
  'ชื่อห้อง': 'Room name',
  'รหัสห้อง': 'Room code',
  'ชั้น': 'Floor',
  'เตียงที่ยังไม่ระบุห้อง': 'Beds without a room',
  'ยังไม่มีเตียงในห้องนี้': 'No beds in this room',
  'สร้างเตียง': 'Create bed',
  'เพิ่มเตียง': 'Add bed',
  'แก้ไขเตียง': 'Edit bed',
  'ชื่อเตียง': 'Bed name',
  'เมนูสำหรับแท็บเลต': 'Tablet menu',
  'เมนูรายการ': 'Item menu',
  'เลือก…': 'Select…',
  'เลือกหมอนวดเพื่อดูรายละเอียด': 'Select a therapist to view details',
  'ดูรายละเอียด': 'View details',
  'ดูเพิ่มเติม': 'Show more',
  'รายละเอียด': 'Details',
  'เพิ่มเติม': 'More',
  'เพิ่มรายการพิเศษ': 'Add adjustment',
  'แก้ไขรายการ': 'Edit item',
  'สร้าง': 'Create',
  'เพิ่ม': 'Add',
  'แก้ไข': 'Edit',
  'ลบ': 'Delete',
  'บันทึกแล้ว': 'Saved',
  'บันทึก': 'Save',
  'กำลังบันทึก…': 'Saving…',
  'กำลังยืนยัน…': 'Confirming…',
  'กำลังลบ…': 'Deleting…',
  'กำลังเคลียร์…': 'Settling…',
  'กำลังเพิ่ม…': 'Adding…',
  'ยืนยัน': 'Confirm',
  'ยกเลิก': 'Cancel',
  'ปิดการใช้งาน': 'Deactivate',
  'เปิดใช้งานอีกครั้ง': 'Reactivate',
  'เปิดใช้งาน': 'Activate',
  'ปิดใช้งาน': 'Deactivate',
  'กลับมาใช้งาน': 'Restore',
  'ไม่ใช้งาน': 'Inactive',
  'ใช้งาน': 'Active',
  'เปิดอยู่': 'Open',
  'เปิด': 'Open',
  'ปิด': 'Closed',
  'สถานะ': 'Status',
  'ประเภท': 'Type',
  'รายการ': 'Items',
  'จำนวน': 'Quantity',
  'คงเหลือ': 'Remaining',
  'ต้นทุน': 'Cost',
  'หมายเหตุ': 'Note',
  'ใส่รายละเอียด': 'Enter details',
  'สร้างโดย': 'Created by',
  'แก้ไขโดย': 'Updated by',
  'วัน-เวลา': 'Date and time',
  'วันที่': 'Date',
  'เริ่มวันที่': 'Start date',
  'ถึงวันที่': 'End date',
  'วันนี้': 'Today',
  'เมื่อวาน': 'Yesterday',
  'เดือนนี้': 'This month',
  '7 วันที่แล้ว': 'Last 7 days',
  'กำหนดเอง': 'Custom',
  'ค้นหา': 'Search',
  'ไม่พบข้อมูล': 'No data found',
  'ไม่พบรายการ': 'No items found',
  'ไม่มีรายการ': 'No items',
  'ไม่มีรายการค้างชำระ': 'No outstanding items',
  'ไม่พบบริการ': 'No services found',
  'ไม่มี': 'None',
  'ไม่กำหนด': 'Not set',
  'ไม่ระบุชื่อ': 'Unnamed',
  'ไม่ระบุห้อง': 'Unassigned room',
  'ไม่ระบุ': 'Not specified',
  'ไม่เปลี่ยน': 'No change',
  'ไม่แสดง': 'Hidden',
  'แสดง': 'Show',
  'ขยาย': 'Expand',
  'ย่อ': 'Collapse',
  'ย้อนกลับ': 'Back',
  'คัดลอก': 'Copy',
  'หน้าหลัก': 'Home',
  'การแจ้งเตือน': 'Notifications',
  'แจ้งเตือน': 'Notifications',
  'ล้างทั้งหมด': 'Clear all',
  'ไม่มีการแจ้งเตือน': 'No notifications',
  'เลือกร้าน': 'Choose organization',
  'โปรไฟล์': 'Profile',
  'เปลี่ยนภาษา': 'Change language',
  'ออกจากระบบ': 'Sign out',
  'ภาษาไทย': 'Thai',
  'ภาษาอังกฤษ': 'English',
  'ชื่อจริง': 'First name',
  'นามสกุล': 'Last name',
  'อีเมล': 'Email',
  'ชื่อเล่น': 'Nickname',
  'รหัส': 'Code',
  'ชื่อ': 'Name',
  'ระบบ': 'System',
  'อื่น ๆ': 'Other',
  'คน': 'people',
  'ครั้ง': 'times',
  'ปี': 'years',
  'นาที': 'minutes',
  'บาท': 'THB',
  'ถึง': 'to',
};

const replacements = Object.entries(EN).sort((a, b) => b[0].length - a[0].length);
const originals = new WeakMap();

export const translateText = (value, locale) => {
  if (locale !== 'en' || typeof value !== 'string') return value;
  return replacements.reduce((text, [thai, english]) => text.split(thai).join(english), value);
};

const ATTRIBUTES = ['placeholder', 'title', 'aria-label'];

function localizeNode(root, locale) {
  const visit = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const current = node.nodeValue;
      if (locale === 'en' && /[ก-๙]/.test(current)) {
        originals.set(node, current);
        const translated = translateText(current, locale);
        if (translated !== current) node.nodeValue = translated;
      } else if (locale === 'th' && originals.has(node)) {
        node.nodeValue = originals.get(node);
        originals.delete(node);
      }
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    // Catalog, customer, therapist, and room names belong to the shop. They
    // must not be substring-translated as if they were application chrome.
    if (node.hasAttribute('data-no-translate')) return;
    ATTRIBUTES.forEach((attribute) => {
      const current = node.getAttribute(attribute);
      if (!current) return;
      const key = `${attribute.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase())}Original`;
      if (locale === 'en' && /[ก-๙]/.test(current)) {
        node.dataset[key] = current;
        node.setAttribute(attribute, translateText(current, locale));
      } else if (locale === 'th' && node.dataset[key]) {
        node.setAttribute(attribute, node.dataset[key]);
        delete node.dataset[key];
      }
    });
    node.childNodes.forEach(visit);
  };
  visit(root);
}

/**
 * Localises existing content and content added by dialogs/dropdowns after the
 * initial render. The observer also covers text returned by APIs, while leaving
 * customer/catalog names alone unless they contain a known UI phrase.
 */
export function DocumentLocalizer({ locale, children }) {
  useEffect(() => {
    const root = document.getElementById('root');
    if (!root) return undefined;
    localizeNode(root, locale);
    document.documentElement.lang = locale;

    let applying = false;
    const observer = new MutationObserver((mutations) => {
      if (applying) return;
      applying = true;
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') localizeNode(mutation.target, locale);
        mutation.addedNodes.forEach((node) => localizeNode(node, locale));
        if (mutation.type === 'attributes') localizeNode(mutation.target, locale);
      });
      applying = false;
    });
    observer.observe(root, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ATTRIBUTES,
    });
    return () => observer.disconnect();
  }, [locale]);

  return children;
}
